export const isEmptyArray = (value) => !Array.isArray(value) || !value.length;
